export default [
  {
    name: 'Meus Dados',
    icon: 'ti-user',
    path: '/perfil'
  },
  {
    name: 'Minhas Avaliações',
    icon: 'ti-view-list-alt',
    path: '/avaliacao/listar'
  },
  {
    name: 'Minha Equipe',
    icon: 'ti-layers-alt',
    path: '/avaliacao/equipe',
    requiresManager: true
  },
  {
    name: 'Código Verificador',
    icon: 'ti-package',
    path: '/avaliacao/codigos'
  },
  {
    name: 'Power University',
    icon: 'br-power-university',
    path: '/power-university',
    requiresManager: true,
    requiresAccessPowerUniversity: true
  }
  // {
  //   name: 'Sobre a Avaliação',
  //   icon: 'ti-calendar',
  //   path: '/sobre'
  // }
  // {
  //   name: 'Desc. de Função',
  //   icon: 'ti-clipboard',
  //   path: '/avaliacao/descritivo'
  // }
]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js